module.exports = __webpack_public_path__ + "static/media/primemodal.d013221d.png";